module.exports = __webpack_public_path__ + "img/copy-link.5f6f26cc.svg";